import styled, {keyframes} from "styled-components";

export const buttonHoverEffect = keyframes`
    0% {width: 0}
    100% {width: 100%}
`

export const Container = styled.div`
  width: 100vw;
  height: ${props => props.height ? props.height : "auto"};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: 80px;

    h1.menu-heading {
        font: italic bold 32px "Roboto Condensed";
        color: #fff;
        text-transform: uppercase;
        margin-top: 3em;

        span {color: #3ee9f7;}
    }
`;

export const MenuGrid = styled.div`
    /* width: 80%; */
    /* display: grid;
    grid-template-columns: repeat(3, minmax(300px, 1fr));
    grid-auto-rows: 280px;
    grid-gap: 2em; */

    display: flex;
    flex-wrap: wrap;
    max-width: ${props => props.maxWidth ? props.maxWidth : '1220px'};

    justify-content: center;
    margin-top: 3em;

`

export const MenuGridItem = styled.div`
    width: 373px;
    height: 289px;
    display: grid;
    grid-template-rows: 100%;
    grid-template-columns: 100%;
    grid-template-areas: "tile";
    place-items: center;
    justify-self: center;
    overflow: hidden;
    border: 1px solid ${props => props.highlightColor ? props.highlightColor : '#acff24'};
    color: #fff;
    margin: 1em;

    .bg-holder {
        grid-area: tile;
        width: 100%;
        height: 100%;
        z-index: 0;
        width: 100%;height: 100%;
        background-image: url(${props => props.backgroundImage});
        background-size: cover;
        transform: rotate(-27deg) translateX(59px) translateY(65px);
    }

    .menu-item-content {
        grid-area: tile;
        width: 100%;
        height: 100%;
        background-color: #000000a1;
        padding: 32px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        z-index: 0;
    }

    h2.menu-item-name {
        font: italic bold 25px "Roboto Condensed";
        text-transform: uppercase;
    }

    p.menu-item-description {
        color: #fff;
    }

    button.menu-item-btn {
        font: italic bold 16px 'Roboto Condensed';
        padding: .25em 1.5em;
        border: 1px solid ${props => props.highlightColor};
        background: transparent;
        color: #fff;
        width: 146px;height: 34px;
        position: relative;
        z-index: 2;
    }

    button.menu-item-btn::before {
        content: '';
        width: 0;
        height: 100%;
        position: absolute;
        background-color: ${props => props.highlightColor};
        top: 0; left: 0;
        z-index: -1;
    }

    button.menu-item-btn:hover {color: black;}


    button.menu-item-btn:hover::before {
        animation: ${buttonHoverEffect} 0.6s ease;
        animation-fill-mode: forwards;
    }

`



// WEBPACK FOOTER //
// ./src/pages/Teachers/TeacherMenu.styles.ts